// Wraps raw PCM bytes (16-bit signed, mono) in a WAV container so the browser
// Audio element can play it. Only used for in-browser preview — never uploaded.
export function pcmBase64ToWavDataUrl(base64, sampleRate = 16000) {
  const pcm = Uint8Array.from(atob(base64.trim().replace(/\s/g, "")), (c) => c.charCodeAt(0));
  const header = new ArrayBuffer(44);
  const v = new DataView(header);
  const w = (o, s) => { for (let i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i)); };
  w(0, "RIFF"); v.setUint32(4, 36 + pcm.length, true);
  w(8, "WAVE"); w(12, "fmt ");
  v.setUint32(16, 16, true);  v.setUint16(20, 1, true);  v.setUint16(22, 1, true);
  v.setUint32(24, sampleRate, true);  v.setUint32(28, sampleRate * 2, true);
  v.setUint16(32, 2, true);  v.setUint16(34, 16, true);
  w(36, "data"); v.setUint32(40, pcm.length, true);
  const wav = new Uint8Array(44 + pcm.length);
  wav.set(new Uint8Array(header));
  wav.set(pcm, 44);
  let bin = "";
  for (let i = 0; i < wav.length; i++) bin += String.fromCharCode(wav[i]);
  return `data:audio/wav;base64,${btoa(bin)}`;
}

export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export const base64ToBlob = async (base64, mimeType) => {
  try {
    if (typeof base64 !== "string") {
      console.error("❌ base64ToBlob expected a string but got:", base64);
      throw new TypeError("base64 must be a string");
    }
    const cleanBase64 = base64.trim().replace(/\s/g, "");

    const byteCharacters = atob(cleanBase64); // decode
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i += 512) {
      const slice = byteCharacters.slice(i, i + 512);
      const byteNumbers = Array.from(slice).map((char) => char.charCodeAt(0));
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: mimeType });
  } catch (error) {
    console.error("❌ base64ToBlob failed:", error, base64);
    throw error;
  }
};

export const generateTextToSpeachVoice = async (textToSpeach, lng, retries = 3) => {
  const ttsBase = import.meta.env.VITE_TTS_URL || "/heycallcenter/api";
  let lastError;
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const response = await fetch(`${ttsBase}/tts`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + (localStorage.getItem("token") || "") },
        body: JSON.stringify({ lang: lng, items: textToSpeach }),
      });
      if (!response.ok) {
        let detail = "";
        try { const body = await response.json(); detail = body?.error ? `: ${body.error}` : ""; } catch {}
        throw new Error(`TTS error ${response.status}${detail}`);
      }
      return response.json();
    } catch (err) {
      lastError = err;
      if (attempt < retries) await new Promise(r => setTimeout(r, 1500 * attempt));
    }
  }
  throw lastError;
};
